<template>
  <div class="card-list">
    <global-loading v-if="$store.state.kpiStore.count_loading" />
    <div class="card-info">
      <div class="card-head">
        Tiket Selesai
      </div>
      <div class="card-value">
        {{ $store.state.kpiStore.tiket_selesai }}
      </div>
    </div>
    <div class="card-split">
      <div class="card-left">
        <div class="card-head">
          CSI Responden
        </div>
        <div class="card-value">
          {{ $store.state.kpiStore.responden }}
        </div>
      </div>
      <div class="card-right">
        <div class="card-head">
          CSI Sistem
        </div>
        <div class="card-value">
          {{ $store.state.kpiStore.system_responden }}
        </div>
      </div>
    </div>
    <div class="card-info">
      <div class="card-head">
        CSI Belum di Nilai
      </div>
      <div class="card-value">
        {{ $store.state.kpiStore.not_yet_assessed }}
      </div>
    </div>
    <div class="card-split">
      <div class="card-left">
        <div class="card-head">
          Tiket Sedang Proses
        </div>
        <div class="card-value">
          {{ $store.state.kpiStore.on_progress }}
        </div>
      </div>
      <div class="card-right">
        <div class="card-head">
          Tiket Rejected <br/> <br/>
        </div>
        <div class="card-value">
          {{ $store.state.kpiStore.reject }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
}
</script>
<style scoped>
.card-list {
  width: 100%;
  /* padding-right: 2rem; */
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}

.card-left,
.card-right,
.card-info {
  box-shadow: -6px 5px 8px 0 rgba(0, 0, 0, 0.2);
}

.card-info {
  background-color: white;
  height: 6rem;
  text-align: center;
  font-size: 0.8rem;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  flex-direction: column;
  width: 100%;
  /* border: 1px solid red; */
}

.card-split {
  width: 100%;
  /* background: white; */
  display: flex;
  height: 6rem;
  flex-direction: row;
  justify-content: space-between;
  text-align: center;
  font-size: 0.8rem;
}

.card-left {
  background: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* padding: 0 1rem; */
  padding: 5px 0px;
  width: 45%;
  height: 100%;
}
.card-right {
  background: white;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* padding: 0 1rem; */
  padding: 5px 0;
  width: 45%;
  height: 100%;
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
}

.card-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: gray;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.card-head {
  font-weight: 600;
}
</style>
